import React, { useState } from 'react'
import AffiliateLayout from './AffiliateLayout'
import DatePicker from 'react-date-picker'
import { Link } from 'react-router-dom'
import UserReport from './UserReport'
import CommissionReport from './CommissionReport'

const AffiliateStatement = () => {
  const [active, setActive] = useState(0)

  return (
    <AffiliateLayout>
      <div className="affi-pd-bot">
        <div
          className="sub-header-tab refer-earn-sec aff-report"
          style={{ marginTop: '12px' }}
        >
          <nav className="affiliate_header">
            <Link
              onClick={() => setActive(0)}
              to="#"
              className={`router-link-active router-link-exact-active ${
                active === 0 ? 'active' : ''
              }`}
            >
              <span>Commission Report</span>
            </Link>
            <Link
              onClick={() => setActive(1)}
              className={`router-link-active router-link-exact-active ${
                active === 1 ? 'active' : ''
              }`}
              to="#"
            >
              <span>User Report</span>
            </Link>
          </nav>
        </div>
        <div>{active === 1 ? <UserReport /> : <CommissionReport />}</div>
      </div>
    </AffiliateLayout>
  )
}

export default AffiliateStatement
